import { Modal, Row } from "react-bootstrap";
import { useRef, useState, useEffect } from "react";
import { useSelector } from "react-redux";

import Role from './RegularComponents/Role';
import Limits from './RegularComponents/Limits';
import Event from './RegularComponents/Event';
import Presenter from './RegularComponents/Presenter';
import Clock from './RegularComponents/Clock';
import Timer from "./RegularComponents/Timer";

export default function Regular({ item, getMeeting, isPlaying, setIsPlaying }) {
  const [backgroundColor, setBackgroundColor] = useState("rgba(0, 0, 0, 0)");
  const [time, setTime] = useState(item?.timer?.time || 0);

  const timerRef = useRef();

  const { user: authUser } = useSelector(x => x.auth)

  // Reset time and stop playing when agenda item changes
  useEffect(() => {
    setTime(item?.timer?.time || 0);
  }, [item]);
  const intervalRef = useRef(null);

  useEffect(() => {
    // Clear any existing interval
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
    if (isPlaying) {
      intervalRef.current = setInterval(() => {
        setTime(prevTime => prevTime + 1);
      }, 1000);
    }
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [isPlaying, item]);

  return (
    <Modal.Body
      style={{
        background: backgroundColor === "rgba(0, 0, 0, 0)"
          ? 'linear-gradient( #003f61 -100%, #78222f 151.58%)'
          : backgroundColor,
        position: 'relative'
      }}
      className='timer-header'
    >
      <Role item={item} />
      {authUser &&
        <Limits item={item} />
      }
      <Event item={item} />
      <Row>
        <Presenter
          item={item}
          getMeeting={getMeeting}
          isPlaying={isPlaying}
          setIsPlaying={setIsPlaying}
          time={time}
          setTime={setTime}
          handleStop={typeof timerRef.current?.handleStop === "function" ? timerRef.current.handleStop : undefined}
        />
        {authUser &&
          <Clock time={time} isPlaying={isPlaying} />
        }
      </Row>
      {authUser &&
        <Timer
          ref={timerRef}
          item={item}
          setBackgroundColor={setBackgroundColor}
          setIsPlaying={setIsPlaying}
          isPlaying={isPlaying}
          getMeeting={getMeeting}
          setTime={setTime}
          time={time}
        />
      }
    </Modal.Body>
  );
}